<template>
  <el-container>
    <el-header>
      <NavHeader :activeIndex="activeIndex" />
    </el-header>
    <el-main>
      <el-row type="flex" justify="center">
        <el-col :span="20">
          <slot></slot>
        </el-col>
      </el-row>
    </el-main>
    <el-footer>Copyright &copy; Zhou Lab 2019</el-footer>
  </el-container>
</template>

<script>
import NavHeader from "./NavHeader.vue";

export default {
  name: "MainLayout",
  props: {
    activeIndex: String
  },
  components: {
    NavHeader
  }
};
</script>

<style>
.el-container {
  height: 100vh;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
}
.el-header {
  border-bottom: solid 1px #e6e6e6;
}
.el-main {
  flex-grow: 1;
  background-color: #f8f8ff;
}
.el-footer {
  text-align: center;
  line-height: 60px;
  border-top: solid 1px #e6e6e6;
}
</style>